import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./persons-section.style.scss";

export const PersonsSection = props => (
  <div
    className={classNames({
      "persons-wrapper": true,
      "d-flex": true,
      "flex-column": true,
      "person-section-hided ": props.hidden,
    })}
  >
    {props.children}
  </div>
);

PersonsSection.propTypes = {
  children: PropTypes.any,
  hidden: PropTypes.bool,
};

export default PersonsSection;
